import React, { useState } from 'react'
import { Box, IconButton, Tooltip } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import PropTypes from 'prop-types'

import DpoDayFloatingLogo from 'images/dpoday-floating-logo.png'

import useStyles from './styles'
import helpers from 'helpers'
import constants from 'constants/index'

const DpoDayFloatingButton = ({ bannerVisible, chatOpen }) => {
  const STORAGE_KEY =
    constants.dpoday.DPO_DAY_FLOATING_BUTTON_STORAGE_KEY_PREFIX
  const [dismissed, setDismissed] = useState(
    sessionStorage.getItem(STORAGE_KEY) === 'hidden',
  )
  const classes = useStyles()

  const handleClick = () => {
    helpers.mixpanel.track('Botão Flutuante DPO Day', 'Clique aqui', {
      action: 'floating_button_click',
      target: constants.dpoday.DPO_DAY_TARGET_URL,
    })

    window.open(
      constants.dpoday.DPO_DAY_TARGET_URL,
      '_blank',
      'noopener,noreferrer',
    )
  }

  const handleClose = (event) => {
    event.stopPropagation()
    setDismissed(true)
    sessionStorage.setItem(STORAGE_KEY, 'hidden')

    helpers.mixpanel.track('Botão Flutuante DPO Day', 'Fechar botão', {
      action: 'close_button_click',
    })
  }

  if (bannerVisible || dismissed || chatOpen) return null

  return (
    <Box className={classes.root}>
      <Tooltip
        title="DPO Day 2027 – Pré-venda exclusiva com 50% de desconto"
        placement="left"
        arrow
      >
        <Box
          className={classes.button}
          onClick={handleClick}
          role="button"
          aria-label="DPO Day 2027 – Pré-venda exclusiva com 50% de desconto"
        >
          <img
            src={DpoDayFloatingLogo}
            alt="DPO Day 2027"
            className={classes.logo}
          />
        </Box>
      </Tooltip>

      <IconButton
        className={classes.closeButton}
        onClick={handleClose}
        size="small"
        aria-label="Fechar"
      >
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
    </Box>
  )
}

DpoDayFloatingButton.propTypes = {
  bannerVisible: PropTypes.bool,
  chatOpen: PropTypes.bool,
}

export default DpoDayFloatingButton
